<template>
    <v-container>
        <creditor-objection-edit-component v-if="user && user.profile == 1"></creditor-objection-edit-component>
        <lawyer-objection-edit-component v-else-if="user && user.profile == 4"></lawyer-objection-edit-component>
    </v-container>
</template>

<script>
import CreditorObjectionEditComponent from '@/components/creditor/CreditorObjectionEditComponent.vue'
import LawyerObjectionEditComponent from '@/components/lawyer/LawyerObjectionEditComponent.vue'

export default {
    components: {
        'creditor-objection-edit-component': CreditorObjectionEditComponent,
        'lawyer-objection-edit-component': LawyerObjectionEditComponent,
    },
    data: () => ({
        user: null,
    }),

    created() {

        this.$ga.event({
            eventCategory: 'page',
            eventAction: 'action',
            eventLabel: 'click',
            eventValue: 'user-area'
        })

        this.user = this.$root.user;
    },
}
</script>

<style lang="scss"></style>